var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoundcloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.320312,
    width: 36,
    height: 36,
    rx: 8,
    fill: "url(#paint0_linear_1026_17846)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1026_17846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.95227 22.4704C8.99589 22.4704 9.03281 22.4345 9.03908 22.384L9.27619 20.5046L9.03978 18.5825C9.03274 18.532 8.99589 18.4958 8.95227 18.4958C8.90752 18.4958 8.8694 18.5328 8.86348 18.5825L8.65625 20.5046L8.86348 22.3833C8.8694 22.4338 8.90752 22.4704 8.95227 22.4704Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.17003 21.7556C8.21287 21.7556 8.24761 21.7222 8.25388 21.6724L8.43765 20.5045L8.25388 19.3148C8.24754 19.2666 8.21287 19.2317 8.17003 19.2317C8.12528 19.2317 8.09062 19.2666 8.08428 19.3155L7.93066 20.5046L8.08428 21.6721C8.09062 21.7215 8.12528 21.7556 8.17003 21.7556Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.88658 18.2248C9.88094 18.1637 9.8362 18.1191 9.78067 18.1191C9.72557 18.1191 9.68076 18.1637 9.67561 18.2248L9.47754 20.5046L9.67561 22.7013C9.68076 22.762 9.72557 22.806 9.78067 22.806C9.8362 22.806 9.88094 22.762 9.88658 22.7013L10.1107 20.5046L9.88658 18.2248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6195 22.8945C10.6844 22.8945 10.737 22.8411 10.7434 22.7712L10.9551 20.5053L10.7434 18.1618C10.737 18.0915 10.6844 18.0386 10.6195 18.0386C10.5536 18.0386 10.5003 18.0915 10.4957 18.1622L10.3086 20.5053L10.4957 22.7712C10.5003 22.8411 10.5536 22.8945 10.6195 22.8945Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4627 22.9313C11.5384 22.9313 11.5991 22.8707 11.6054 22.7896L11.6047 22.7902L11.8041 20.5053L11.6047 18.331C11.599 18.2513 11.5384 18.1898 11.4626 18.1898C11.3858 18.1898 11.3254 18.2513 11.3208 18.3317L11.1445 20.5054L11.3208 22.7897C11.3255 22.8707 11.3859 22.9313 11.4627 22.9313Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6606 20.5059L12.4735 16.9706C12.4683 16.881 12.3985 16.8095 12.3128 16.8095C12.2277 16.8095 12.1581 16.8809 12.1529 16.9706L11.9873 20.5059L12.1529 22.7902C12.1581 22.8802 12.2278 22.9507 12.3128 22.9507C12.3985 22.9507 12.4683 22.8802 12.4735 22.7902V22.7908L12.6606 20.5059Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1722 22.9544C13.2665 22.9544 13.3448 22.8761 13.3492 22.7762V22.7777L13.5241 20.5065L13.3492 16.1619C13.3448 16.062 13.2665 15.9837 13.1722 15.9837C13.0756 15.9837 12.998 16.062 12.9928 16.1619L12.8389 20.5065L12.9935 22.7769C12.998 22.8761 13.0756 22.9544 13.1722 22.9544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0359 15.6029C13.9297 15.6029 13.8439 15.6901 13.8395 15.8001L13.6963 20.5072L13.8395 22.7538C13.844 22.8633 13.9297 22.9499 14.0359 22.9499C14.1419 22.9499 14.2283 22.864 14.232 22.7535V22.7546L14.3946 20.5072L14.232 15.8001C14.2283 15.6894 14.1418 15.6029 14.0359 15.6029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9072 22.9544C15.0239 22.9544 15.1168 22.8603 15.1212 22.7391V22.7404L15.2715 20.5072L15.1212 15.6421C15.1167 15.5213 15.0239 15.4267 14.9072 15.4267C14.7898 15.4267 14.6954 15.5213 14.6936 15.6421L14.5586 20.5072L14.6936 22.7404C14.6954 22.8603 14.7898 22.9544 14.9072 22.9544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7859 22.9522C15.9119 22.9522 16.014 22.8491 16.0178 22.7184V22.7204L16.1561 20.5076L16.0178 15.7661C16.014 15.6355 15.9119 15.5328 15.7859 15.5328C15.6591 15.5328 15.5569 15.6354 15.5532 15.7661L15.4316 20.5076L15.554 22.7194C15.5569 22.8491 15.6591 22.9522 15.7859 22.9522Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0459 20.5076L16.9207 15.939C16.9176 15.7981 16.8073 15.6874 16.6704 15.6874C16.5332 15.6874 16.4228 15.7981 16.4199 15.9399L16.3076 20.5076L16.4199 22.7059C16.4228 22.8457 16.5332 22.9565 16.6704 22.9565C16.8072 22.9565 16.9176 22.8457 16.9207 22.7039V22.7059L17.0459 20.5076Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5618 22.9606C17.7073 22.9606 17.8277 22.8396 17.8299 22.6908V22.692L17.9436 20.5088L17.8299 15.0723C17.8278 14.923 17.7073 14.8022 17.5618 14.8022C17.4165 14.8022 17.2964 14.9236 17.2934 15.0731L17.1924 20.5066L17.2934 22.6921C17.2964 22.8396 17.4165 22.9606 17.5618 22.9606Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4504 14.2908C18.2934 14.2908 18.166 14.4211 18.1634 14.5799L18.0459 20.5095L18.1641 22.6605C18.166 22.8172 18.2934 22.9471 18.4504 22.9471C18.6051 22.9471 18.7349 22.8172 18.7356 22.6578V22.6605L18.8638 20.5095L18.7356 14.5799C18.7349 14.4205 18.6051 14.2908 18.4504 14.2908Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2627 22.9626C19.269 22.9632 26.4234 22.9666 26.4693 22.9666C27.9057 22.9666 29.0697 21.7883 29.0697 20.3342C29.0697 18.881 27.9057 17.7025 26.4693 17.7025C26.1129 17.7025 25.7732 17.7753 25.4635 17.9073C25.2576 15.5347 23.2921 13.6741 20.8945 13.6741C20.3083 13.6741 19.7368 13.7912 19.232 13.989C19.0356 14.0658 18.983 14.145 18.9814 14.2985V22.6512C18.9837 22.8125 19.1067 22.9466 19.2627 22.9626Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1026_17846",
    x1: 18.5,
    y1: 0.320312,
    x2: 18.5,
    y2: 36.3203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A01D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF5826"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1026_17846"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.1391,
    height: 21.1391,
    fill: "white",
    transform: "translate(7.93066 7.75076)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundcloud);
export default __webpack_public_path__ + "static/media/soundcloud.631df79a.svg";
export { ForwardRef as ReactComponent };